import * as types from './actionTypes';  
import allocationOfferingApi from '../api/allocationOfferingApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchAllocationOffering(id) {

  return {
    type: types.DO_FETCH_ALLOCATION_OFFERING,
    id
  };
}

export function doFetchAllocationOfferingRes(data) {  
  return {
    type: types.DO_FETCH_ALLOCATION_OFFERING_RES, 
    data
  };
}
export function fetchAllocationOffering(id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      allocationOfferingApi.doFetchAllocationOffering(id).then(data => {
        dispatch(doFetchAllocationOfferingRes(data));
        dispatch(doFetchAllocationOfferingRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}